

/**
 * Calculate a time difference between two times
 * @param current = int (timestamp, ms)
 * @param previous = int (timestamp, ms)
 * @return obj = (status, content)
 **/
export function timeDifference(current, previous){

	var msPerMinute = 60 * 1000;
	var msPerHour = msPerMinute * 60;
	var msPerDay = msPerHour * 24;
	var elapsed = current - previous;
	var content = null;
	var status = 'default';
	
	if (elapsed < msPerMinute){
	
		var count = Math.round(elapsed/1000);
		if (count < 15){
			content = 'Just now';
		} else if( count < 30 ){
			content = '15 sec ago';
		} else if( count < 45 ){
			content = '30 sec ago';
		} else if( count < 60 ){
			content = '45 sec ago';
		}
		
	} else if (elapsed < msPerHour){
	
		var count = Math.round(elapsed/msPerMinute);
		if (count == 1){
			content = count+' min ago';
		} else {
			content = count+' mins ago';
		}
		
		if (count >= 15){
			status = 'alert';
		}
			
	} else if (elapsed < msPerDay){
	
		var count = Math.round(elapsed/msPerHour);
		if (count == 1){
			content = count+' hour ago';   
		} else {
			content = count+' hours ago';
		}
		status = 'alert';
		
	} else {
	
		status = 'alert';
		content = 'Over 1 day ago';
		
	}
	
	return {
		status: status,
		content: content
	};
}